import ReactDOM from 'react-dom';

import { ICommonModal } from './interface';

abstract class CommonModal<T> implements ICommonModal<T> {
  options: T;

  modalContainer: HTMLDivElement;

  constructor(options: T) {
    this.options = options;
    this.modalContainer = document.createElement('div');
    document.body.appendChild(this.modalContainer);
    this.render(true, options);
  }

  abstract render(visible: boolean, options: T): void;

  destroy(): void {
    ReactDOM.unmountComponentAtNode(this.modalContainer);
    document.body.removeChild(this.modalContainer);
  }

  update(options: T): void {
    this.render(false, options);
  }

  close(): void {
    this.render(false, this.options);
  }
}

export default CommonModal;
